/**
 * MBTI 16型人格特征管理
 * 用于AI陪练应用中的角色性格设定
 */
import i18n from '../i18n';

export interface MBTIType {
  key: string;
  name: string;
  description: string;
  aiCoachingApplication: string;
}

// MBTI 16型人格特征数据
export const MBTI_TYPES: MBTIType[] = [
  {
    key: 'INTJ',
    name: 'mbti.INTJ.name',
    description: 'mbti.INTJ.description',
    aiCoachingApplication: 'mbti.INTJ.application'
  },
  {
    key: 'INTP',
    name: 'mbti.INTP.name',
    description: 'mbti.INTP.description',
    aiCoachingApplication: 'mbti.INTP.application'
  },
  {
    key: 'ENTJ',
    name: 'mbti.ENTJ.name',
    description: 'mbti.ENTJ.description',
    aiCoachingApplication: 'mbti.ENTJ.application'
  },
  {
    key: 'ENTP',
    name: 'mbti.ENTP.name',
    description: 'mbti.ENTP.description',
    aiCoachingApplication: 'mbti.ENTP.application'
  },
  {
    key: 'INFJ',
    name: 'mbti.INFJ.name',
    description: 'mbti.INFJ.description',
    aiCoachingApplication: 'mbti.INFJ.application'
  },
  {
    key: 'INFP',
    name: 'mbti.INFP.name',
    description: 'mbti.INFP.description',
    aiCoachingApplication: 'mbti.INFP.application'
  },
  {
    key: 'ENFJ',
    name: 'mbti.ENFJ.name',
    description: 'mbti.ENFJ.description',
    aiCoachingApplication: 'mbti.ENFJ.application'
  },
  {
    key: 'ENFP',
    name: 'mbti.ENFP.name',
    description: 'mbti.ENFP.description',
    aiCoachingApplication: 'mbti.ENFP.application'
  },
  {
    key: 'ISTJ',
    name: 'mbti.ISTJ.name',
    description: 'mbti.ISTJ.description',
    aiCoachingApplication: 'mbti.ISTJ.application'
  },
  {
    key: 'ISFJ',
    name: 'mbti.ISFJ.name',
    description: 'mbti.ISFJ.description',
    aiCoachingApplication: 'mbti.ISFJ.application'
  },
  {
    key: 'ESTJ',
    name: 'mbti.ESTJ.name',
    description: 'mbti.ESTJ.description',
    aiCoachingApplication: 'mbti.ESTJ.application'
  },
  {
    key: 'ESFJ',
    name: 'mbti.ESFJ.name',
    description: 'mbti.ESFJ.description',
    aiCoachingApplication: 'mbti.ESFJ.application'
  },
  {
    key: 'ISTP',
    name: 'mbti.ISTP.name',
    description: 'mbti.ISTP.description',
    aiCoachingApplication: 'mbti.ISTP.application'
  },
  {
    key: 'ISFP',
    name: 'mbti.ISFP.name',
    description: 'mbti.ISFP.description',
    aiCoachingApplication: 'mbti.ISFP.application'
  },
  {
    key: 'ESTP',
    name: 'mbti.ESTP.name',
    description: 'mbti.ESTP.description',
    aiCoachingApplication: 'mbti.ESTP.application'
  },
  {
    key: 'ESFP',
    name: 'mbti.ESFP.name',
    description: 'mbti.ESFP.description',
    aiCoachingApplication: 'mbti.ESFP.application'
  }
];

// 获取MBTI类型选项（用于下拉选择）
export const getMBTIOptions = () => {
  return MBTI_TYPES.map(type => ({
    value: type.key,
    label: `${type.key} - ${i18n.t(type.name)}`,
    description: i18n.t(type.aiCoachingApplication)
  }));
};

// 根据key获取MBTI类型信息
export const getMBTITypeByKey = (key: string): MBTIType | undefined => {
  return MBTI_TYPES.find(type => type.key === key);
};

// 获取MBTI类型的显示名称
export const getMBTIDisplayName = (key: string): string => {
  const type = getMBTITypeByKey(key);
  return type ? `${type.key} - ${i18n.t(type.name)}` : key;
};
